var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_433_3853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5407 5.93144C21.4132 5.49562 21.17 5.09854 20.8346 4.77859C20.4991 4.45864 20.0828 4.22663 19.626 4.105C17.9112 3.66676 11.0098 3.66676 11.0098 3.66676C11.0098 3.66676 4.12582 3.65801 2.39359 4.105C1.9367 4.22663 1.52043 4.45864 1.18502 4.77859C0.849603 5.09854 0.606386 5.49562 0.478876 5.93144C0.153815 7.60613 -0.00644056 9.30613 0.000198067 11.0093C-0.00518556 12.706 0.155066 14.3995 0.478876 16.0679C0.606386 16.5036 0.849603 16.9007 1.18502 17.2207C1.52043 17.5407 1.9367 17.7727 2.39359 17.8943C4.10656 18.3334 11.0098 18.3334 11.0098 18.3334C11.0098 18.3334 17.8928 18.3334 19.626 17.8943C20.0828 17.7727 20.4991 17.5407 20.8346 17.2207C21.17 16.9007 21.4132 16.5036 21.5407 16.0679C21.8577 14.3989 22.0112 12.7054 21.9993 11.0093C22.0125 9.30674 21.859 7.60674 21.5407 5.93144ZM8.80714 14.1504V7.85848L14.5513 11.0093L8.80714 14.1504Z",
    fill: "#FDF4F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_433_3853"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.3f7af7eaaadd8eac654dcab1a52b0218.svg";
export { ForwardRef as ReactComponent };